export const PROFESSIONAL_USE_EVIDENCE = Object.freeze([
  {
    id: 'satepsi-mini-mental-nonexclusive',
    authority: 'Conselho Federal de Psicologia — SATEPSI',
    asOf: '2026-08-14',
    resultType: 'regulatory-classification',
    results: {
      instrument: 'TESTE MINI-MENTAL',
      classification: 'não privativo',
      psychologicalTest: false
    },
    limitations: [
      'Classificação como não privativo não equivale a autorização irrestrita para qualquer pessoa ou profissão.',
      'A lista do SATEPSI pode ser atualizada; a situação deve ser conferida periodicamente.'
    ],
    source: { kind: 'official-url', value: 'https://satepsi.cfp.org.br/testesNaoPrivativos.cfm' },
    usedBy: ['/quem-pode-aplicar']
  },
  {
    id: 'cfp-psychological-tests-exclusive-2026',
    authority: 'Conselho Federal de Psicologia',
    asOf: '2026-07-28',
    resultType: 'regulatory-guidance',
    results: {
      psychologicalTestsExclusiveToPsychology: true,
      distinctionFromNonexclusiveInstrumentsRequired: true
    },
    limitations: [
      'A orientação trata de testes psicológicos; não transforma instrumentos classificados pelo próprio SATEPSI como não privativos em testes psicológicos privativos.'
    ],
    source: { kind: 'official-url', value: 'https://site.cfp.org.br/cfp-destaca-que-aplicacao-de-testes-psicologicos-e-pratica-privativa-da-psicologia/' },
    usedBy: ['/quem-pode-aplicar']
  }
]);

export function getProfessionalUseEvidenceById(id) {
  return PROFESSIONAL_USE_EVIDENCE.find((item) => item.id === id);
}
